import { Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { Container } from './ResultsSummary.style';

const messages = defineMessages({
  showing: {
    id: 'resultsSummary.showing',
    defaultMessage: 'Showing {shown} of {total} {label}',
  },
});

interface ResultsSummaryProps {
  /** Number of rows matching the currently active filters/search. */
  shown: number;
  /** Static total for the currently active tab, unaffected by filters. */
  total: number;
  /** Already-localized plural noun for the active tab, e.g. "patients". */
  label: string;
}

export default function ResultsSummary({
  shown,
  total,
  label,
}: ResultsSummaryProps) {
  const { formatMessage } = useIntl();

  return (
    <Container>
      <Typography color="text.secondary" variant="body2">
        {formatMessage(messages.showing, { shown, total, label })}
      </Typography>
    </Container>
  );
}
